import {
  sentryGlobalFunctionMiddleware,
  sentryGlobalRequestMiddleware,
} from '@sentry/tanstackstart-react';
import { createCsrfMiddleware, createStart } from '@tanstack/react-start';

// TanStack Start auto-installs CSRF protection for server functions ONLY when
// no custom start.ts exists. Since we define one (for Sentry), we must add it
// back explicitly. It validates Sec-Fetch-Site/Origin/Referer headers and
// rejects requests that can't be proven same-origin.
const csrfMiddleware = createCsrfMiddleware({
  filter: (ctx) => ctx.handlerType === 'serverFn',
});

// Sentry middlewares must be FIRST in each array so they wrap every other
// middleware and capture errors from API routes and server functions.
export const startInstance = createStart(() => ({
  functionMiddleware: [sentryGlobalFunctionMiddleware],
  requestMiddleware: [sentryGlobalRequestMiddleware, csrfMiddleware],
}));
